// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProgressBar_wrapper__1N4hl","bar":"ProgressBar_bar__2zhWP"};